import React from 'react'

const ModalListDays = ({ setChoiceDay, _display60Days, staff }) => { 
    return ( 
        <div class="modal fade" id="modalListDays" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                
                    <div class="modal-header">
                        <h5 class="modal-title" id="modalListDays">Choisir une date</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                    {_display60Days().map((d,i) => (

                        <div key={'d'+i} className='row'>

                            {/* Y A T IL UN STAFF DISPO A CETTE DATE ? ARE THERE STAFF AVAILABLE AT THIS DATE */}
                            {staff.filter(st => st[d.day+'open'] === true && [st[d.day+'amOpen'] === true || st[d.day+'pmOpen'] === true]).map(st => st.id).length === 0 ? null :

                            <div 
                                data-bs-dismiss="modal" 
                                className='border-bottom mb-1 pb-1 text-center'  
                                style={{ height:'2rem'}}
                                onClick={() => setChoiceDay(d.date)}
                            >{d.dateShow}</div>
                            }

                        </div>

                    ))}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalListDays

/*
<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
*/